export default {
    nav: {
        home: 'Home',
        contact: 'Contact',
        about: 'About Us',
        join: 'Careers',
        dataService: 'Data Service'
    },
    button: {
        login: 'Member Login',
        logout: 'Logout',
        openLogin: 'Open Login Window'
    },
    message: {
        loginRequired: 'Please login first',
        loginStatusChanged: 'Navigation bar detected login status change:',
        debugJumpTo: '[DEBUG] jumpTo(item):',
        eventBusError: 'Event bus not registered, please add in main.js: Vue.prototype.$bus = new Vue()'
    },
    footer: {
        about: 'About Us',
        philosophy: 'Company Philosophy',
        contact: 'Contact Us',
        careers: 'Careers',
        copyright: 'Copyright © 2009-2098 www.meituodata.com All Rights Reserved.',
        icp: 'Zhejiang ICP No.20027945-1',
        phone: 'Tel: 18969418571 (WeChat same number)',
        address: 'Address: Room 1406, Jingu Building, 387 Gudun Road, Xihu District, Hangzhou'
    },
    el: {
        pagination: {
            total: 'Total {total}',        // 总计显示
            goto: 'Go to',                 // 跳转按钮
            pageClassifier: 'Page',       // 数量单位
            pageSize: '',    // 每页条数标签
            pagesize: '',    // 每页条数标签
            page_size: 'items per page',    // 每页条数标签
            currentPage: 'current page',   // 当前页标签
            prevPage: 'previous page',     // 上一页
            nextPage: 'next page',         // 下一页
            prev5: 'previous 5 pages',     // 向前5页
            next5: 'next 5 pages',         // 向后5页
            pagerCount: 'pager count'      // 页码数量
        },
        datepicker: {
            now: 'Now',
            today: 'Today',
            cancel: 'Cancel',
            clear: 'Clear',
            confirm: 'Confirm',
            selectDate: 'Select date',
            selectTime: 'Select time'
        }
    },
    home_page:{
        item_data: "Data",
        items: " Total",
        export: "export",
        export_page: "export current",
        export_all: "export all",
        export_last_time: "last modified at",
        advanced_search: "Advanced",
        advanced_search_add: "add",
        advanced_search_condition: "Condition",
        advanced_search_result: "     totals",
        advanced_search_button: "Search",
        advanced_search_reset_button: "Reset",
        advanced_search_loading: "Loading"
    },
    index: {
        banner: {
            title: "Focused on Pharmaceutical Information Services",
            content: "Over 10 years of industry experience with professional data support. Global exhibition participation: CPHI, API, CAC, FIC and other international exhibitions. Professional Data Analysis: Real, effective, sincere and professional market consulting. Professional Data Services: Real, effective, sincere and professional market consulting.",
            images: [
                "/img/bg1.jpg", // 实验室场景图
                "/img/bg2.jpg", // 医药展会现场
                "/img/bg3.jpg"  // 数据分析图表
            ]
        },
        company: {
            name: "Hangzhou Meituo Pharmaceutical Technology Co., Ltd.",
            intro: "A pharmaceutical information company located in Hangzhou, by the beautiful West Lake, specializing in information data services for pharmaceuticals, pesticides, biology, chemicals, etc. We provide real, effective, sincere and professional data information and market consulting to customers at home and abroad.",
            experience: "With over 10 years of focus on the pharmaceutical and chemical industry, we have established good relations and cooperation with most domestic pharmaceutical export enterprises, and regularly participate in exhibitions such as CPHI, API, CAC, and FIC."
        },
        services: {
            title: "Core Services",
            data: {
                title: "Data Information Services",
                desc: "Provide professional data information for pharmaceutical, pesticide, biological, chemical and other industries to assist customer decision-making"
            },
            consulting: {
                title: "Market Consulting",
                desc: "Sincere and professional market analysis and consulting services to provide strategic support for enterprise development"
            },
            cooperation: {
                title: "Enterprise Cooperation Connection",
                desc: "Connect domestic and foreign pharmaceutical enterprises to promote technical exchanges and business cooperation"
            },
            exhibition: {
                title: "Exhibition Services",
                desc: "Provide international exhibition participation support to expand enterprises' global vision"
            }
        },
        exhibitions: {
            title: "International Exhibition Participation",
            cphi: {
                name: "CPHI Worldwide",
                desc: "The world's leading exhibition for pharmaceutical ingredients and manufacturing equipment"
            },
            api: {
                name: "API China",
                desc: "China's premier pharmaceutical ingredients exhibition"
            },
            cac: {
                name: "CAC Exhibition",
                desc: "The world's leading professional exhibition for agricultural chemicals"
            },
            fic: {
                name: "FIC Exhibition",
                desc: "Asia's leading professional exhibition for food additives and ingredients"
            }
        },
        clients: {
            title: "Cooperative Clients",
            desc: "Established good relations and cooperation with most domestic pharmaceutical export enterprises",
            list: ["Client Enterprise A", "Client Enterprise B", "Client Enterprise C", "Client Enterprise D", "Client Enterprise E", "Client Enterprise F"]
        },
        contact: {
            title: "Contact Us",
            email: "E-Mail"
        }
    },
    contact: {
        title: "Contact Us",
        subtitle: "We look forward to connecting with you and providing professional medical information services",
        contactInfo: "Contact Information",
        companyName: "Hangzhou Meituo Pharmaceutical Technology Co., Ltd.",
        phone: "Phone Number",
        phone_detail: "18969418571(Wechat)",
        address: "Company Address",
        address_detail: "Room 1406, Jingu Building, 387 Gudun Road, Xihu District, Hangzhou",
        email: "Email Address",
        workingHours: "Working Hours",
        weekdays: "Monday to Friday: 9:00 - 18:00",
        weekends: "Saturday to Sunday: Closed",
        advantages: "Our Advantages",
        dataService: "Professional Data Services",
        dataServiceDesc: "Over 10 years of pharmaceutical industry data accumulation, providing accurate and comprehensive market analysis",
        customerResources: "High-Quality Customer Resources",
        customerResourcesDesc: "Established long-term stable cooperative relationships with most domestic pharmaceutical export enterprises",
        internationalVision: "International Perspective",
        internationalVisionDesc: "Participate in internationally renowned pharmaceutical exhibitions all year round, grasp global market dynamics",
        professionalTeam: "Professional Team",
        professionalTeamDesc: "Possess an experienced and highly professional medical information service team",
        process: "Cooperation Process",
        step1: "Needs Consultation",
        step1Desc: "Customers put forward needs, we provide initial consultation services",
        step2: "Program Customization",
        step2Desc: "Develop personalized service plans according to customer needs",
        step3: "Cooperation Contract Signing",
        step3Desc: "Both parties confirm cooperation details and sign service contracts",
        step4: "Project Execution",
        step4Desc: "Professional team executes service projects as planned",
        step5: "After-sales Follow-up",
        step5Desc: "Regular return visits to provide continuous technical support",
        testimonials: "Customer Evaluations",
        testimonial1: "\"The market data analysis report provided by Meituo Pharmaceutical is very professional, helping us grasp industry trends in a timely manner and providing strong support for company decision-making. - Marketing Director, a large pharmaceutical export enterprise\"",
        testimonial2: "\"Cooperating with Meituo Pharmaceutical for many years, their services have always maintained a high standard, the team responds quickly, and the data is accurate and reliable. They are our trusted partner. - General Manager, a biotechnology company\"",
        companyEnv: "Company Environment",
        companyLocation: "Company Location",
        viewMap: "View Map"
    },
    about: {
        pageTitle: "About Us",
        pageSubtitle: "Focus on Pharmaceutical Technology, Lead Industry Innovation",

        // Company Profile
        companyProfile: "Company Profile",
        companyIntro: "Hangzhou Meituo Pharmaceutical Technology Co., Ltd was established on July 30, 2010, with its registered address at Room 821, South Building, Yefeng Modern Center, No. 161 Shaoxing Road, Gongshu District (formerly Xiacheng District), Hangzhou.",
        companyDesc: "The company focuses on technology development and consulting services in the pharmaceutical and medical device fields, belonging to scientific research and technical services industry. We are committed to providing professional and efficient pharmaceutical information solutions for customers, helping the pharmaceutical industry innovate and develop.",
        companyHistory: "After years of development, the company has established stable cooperative relationships with many domestic pharmaceutical enterprises and built a good reputation and brand image in the industry.",

        // Core Team
        coreTeam: "Core Team",
        member1Name: "Wen Haiyan",
        member1Title: "Legal Representative, Executive Director and General Manager",
        member1Share: "Shareholding Ratio: 80%",
        member1Bio: "Responsible for the company's overall strategic planning and operation management, with rich experience in the pharmaceutical industry and management experience.",
        member2Name: "Jia Chenxi",
        member2Title: "Supervisor",
        member2Share: "Shareholding Ratio: 20%",
        member2Bio: "Responsible for the company's supervision and management work, with a profound professional background in pharmaceutical technology.",

        // Development History
        developmentHistory: "Development History",
        timeline2010Title: "Company Establishment",
        timeline2010Desc: "Hangzhou Meituo Pharmaceutical Technology Co., Ltd was formally established on July 30, with its registered address at Room 821, South Building, Yefeng Modern Center, No. 161 Shaoxing Road, Gongshu District, Hangzhou.",
        timeline2015Title: "Business Expansion",
        timeline2015Desc: "Expanded business scope, began to focus on technology development and consulting services in the pharmaceutical and medical device fields, and established cooperative relationships with multiple pharmaceutical enterprises.",
        timeline2020Title: "Industry Recognition",
        timeline2020Desc: "The company has been widely recognized in the pharmaceutical information service field and has become a long-term partner of many well-known pharmaceutical enterprises.",
        timeline2025Title: "Continuous Development",
        timeline2025Desc: "The company continues to expand service scope, improve professional service capabilities, and is committed to becoming a leading enterprise in the pharmaceutical technology service field.",

        // Company Vision
        companyVision: "Company Vision",
        mission: "Mission",
        missionDesc: "Through professional pharmaceutical information services, assist the innovative development of the pharmaceutical industry and contribute to the cause of human health.",
        vision: "Vision",
        visionDesc: "To become a leading domestic pharmaceutical technology service provider, lead industry development and create greater value.",
        values: "Values",
        valuesDesc: "Professionalism, Integrity, Innovation, Excellence, customer-centric, quality as life.",

        // Basic Information
        basicInfo: "Basic Company Information",
        infoName: "Company Name",
        infoDate: "Establishment Time",
        infoAddress: "Registered Address",
        infoBusiness: "Business Scope",
        infoType: "Company Type",
        infoValueName: "Hangzhou Meituo Pharmaceutical Technology Co., Ltd",
        infoValueDate: "July 30, 2010",
        infoValueAddress: "Room 821, South Building, Yefeng Modern Center, No. 161 Shaoxing Road, Gongshu District (formerly Xiacheng District), Hangzhou",
        infoValueBusiness: "Technology development and consulting services in the pharmaceutical and medical device fields",
        infoValueType: "Limited liability company invested and controlled by natural persons"
    },
    careers: {
        pageTitle: "Join Meituo Pharmaceutical, Create a Better Future for Pharmaceutical Technology",
        jobTitle: "Job Title",
        jobDuties: "Job Responsibilities",
        jobRequirements: "Qualifications",
        jobBonus: "Preferred Qualifications",
        jobBenefits: "Benefits",
        contactUs: "Contact Us",
        email: "Recruitment Email",
        emailNote: "Email Subject: Position Applied for + Name",
        phone: "Contact Phone",
        phone_detail: "18969418571(Wechat)",
        address: "Company Address",
        infoValueAddress: "Room 821, South Building, Yefeng Modern Center, No. 161 Shaoxing Road, Gongshu District (formerly Xiacheng District), Hangzhou",
        jobs: [
            {
                title: "AI Technology Director",
                duties: [
                    "Responsible for the planning, design, development and implementation of the company's AI technology to ensure the feasibility and effectiveness of technical solutions;",
                    "Lead the team in technical research and development to promote the continuous innovation and development of the company's AI technology;",
                    "Responsible for the application and promotion of AI technology to improve the company's competitiveness in the industry;",
                    "Responsible for the maintenance and upgrade of AI technology to ensure system stability and security;",
                    "Work closely with other departments of the company to coordinate technical resources and provide technical support for the company's business development."
                ],
                requirements: [
                    "Bachelor's degree or above in computer science, artificial intelligence or related fields;",
                    "More than 5 years of work experience in AI technology, team management experience is preferred;",
                    "Familiar with AI technologies such as machine learning, deep learning, natural language processing, with strong technical research and development capabilities;",
                    "Good communication, coordination and team management skills, able to effectively promote team work;",
                    "Strong learning ability and innovation awareness, able to continuously learn and master new technologies and knowledge;",
                    "Strong sense of responsibility and execution, able to work under pressure and challenges."
                ],
                bonus: ["Industry experience in: Enterprise Services · Artificial Intelligence"],
                benefits: []
            },
            {
                title: "Pharmacy Director",
                requirements: [
                    "First academic degree: undergraduate, doctoral degree, senior professional title;",
                    "At least 8 years of work experience in this profession in university affiliated hospitals, provincial hospitals or tertiary hospitals;",
                    "Research achievements and management experience are preferred;",
                    "Under 50 years old."
                ],
                benefits: [
                    "Income: Negotiable annual salary + research incentives + special talent allowance;",
                    "Settling-in allowance: Evaluated according to district talent introduction policy;",
                    "Research start-up fund: Negotiable;",
                    "Provide talent housing and housing subsidies;",
                    "Assist in solving spouse's work and children's education problems."
                ],
                duties: [],
                bonus: []
            },
            {
                title: "Pharmacist",
                duties: [
                    "Dispense Chinese herbal medicines into pharmaceuticals for customer use according to physician prescriptions;",
                    "Proficient in identifying Chinese herbal medicines and familiar with Chinese medicine compatibility taboos;",
                    "Consciously perform pharmacist duties and dispense prescriptions according to dispensing standards;",
                    "Able to independently complete prescription review, medicine preparation, packaging, and decoction; responsible for drug acceptance, quality assurance, maintenance, inventory management, etc;",
                    "Carry out pharmacy-related work under the leadership of the pharmacy supervisor;",
                    "Pharmacy work experience is preferred;",
                    "Obey arrangements and complete other tasks assigned by superiors."
                ],
                requirements: [
                    "Hard requirement: Possess a Chinese pharmacist (technician) qualification certificate issued by the health system, undergraduate degree or above;",
                    "More than 1 year of pharmacy work experience or more than 1 year of Chinese herbal medicine dispensing experience is preferred;",
                    "Familiar with drug laws and regulations, able to independently complete job responsibilities;",
                    "Good communication skills, friendly, rigorous and meticulous, with team spirit."
                ],
                bonus: [],
                benefits: []
            },
            {
                title: "Pharmaceutical R&D Director",
                duties: [
                    "Responsible for establishing a drug design platform, designing novel molecular structures with intellectual property rights, discovering new drug lead compounds and obtaining preclinical candidate drugs through structural optimization;",
                    "Responsible for establishing and maintaining drug synthesis platforms and analysis platforms to ensure that all synthesis and analysis experiments are conducted in a standardized and orderly manner;",
                    "Responsible for establishing and improving the innovative drug research and development laboratory management system and project management system to ensure that innovative drug discovery projects are carried out in a standardized and orderly manner;",
                    "Responsible for reviewing the rationality and necessity of external commissioned research by the department. Responsible for reviewing patent-related parts;",
                    "Responsible for the daily management of the department. Responsible for the performance appraisal of the Innovative Drug Research and Development Department 1 and the formulation of relevant systems. Responsible for formulating personnel training and team building plans for the Innovative Drug Research and Development Department 1 to ensure implementation in the department;",
                    "Responsible for coordination and connection between departments, providing necessary resource support for project management to ensure the smooth progress of each project's research and development work. Responsible for coordinating and communicating with relevant departments to clarify the procurement, auditing, sample trial production, inspection, warehousing and other needs of R&D projects in the Innovative Drug Research and Development Department 1;",
                    "Responsible for implementing departmental safety management systems and safety responsibilities to ensure that all work is carried out under safe conditions, and bears direct management responsibility for the safety work of the Innovative Drug Research and Development Department 1;",
                    "Responsible for the occupational health, safety and environmental management of the department, implement the work arrangements of the company's safety committee, earnestly implement safety production and environmental protection measures, and complete the annual EHS management objectives;",
                    "Responsible for completing other related work assigned by superiors."
                ],
                requirements: [
                    "Education: Doctoral degree or above;",
                    "Major: Organic synthesis, medicinal chemistry and related majors;",
                    "Work experience: More than 10 years of candidate drug research and development experience, served as the director or above of the new drug pharmaceutical research and development department, with more than 5 years of new drug pharmaceutical research and development management experience. Overseas innovative drug research and development background is preferred;",
                    "Professional knowledge/skills: Master national policies and regulations on innovative drug research and development, familiar with the R&D process of innovative drug discovery stage, good coordination, communication and R&D management capabilities. Master domestic and foreign innovative drug research and development trends, proficient in medicinal chemistry molecular design and synthetic route design, proficient in patent requirements, master pharmacological, pharmacokinetic and toxicological and other related pharmaceutical professional knowledge;",
                    "Language requirements: Proficient in reading English literature patents, with good English listening, speaking, reading and writing skills;",
                    "Required qualities and abilities: Good coordination, communication and R&D management capabilities; good hands-on ability and learning ability. Certain ability to work under pressure; dedicated, responsible; extensive information channels, clear R&D ideas, accurate R&D orientation, decisive decision-making ability and good leadership."
                ],
                bonus: [],
                benefits: []
            }
        ]
    },
    lang: {
        'zh-CN': 'Chinese',
        'en-US': 'English'
    }
};